import React from 'react';
import cn from 'classnames';

import { analytics, getClickCtaDetail } from '@/utils/analytics';

import Text from '@/atoms/Text/Text';
import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';
import RichText from '@/molecules/RichText/RichText';
import { DynamicAsset } from '@/molecules/Media/index';
import CtfCta from '@/molecules/CTA/index';

function ProductsKind({ entries = [], fields = {} }) {
  const {
    title,
    superTitle,
    contentText,
    fitFor,
    marbleScore,
    cloudinaryAssets,
    callToAction,
  } = fields;

  const fitForListArray = fitFor !== undefined ? fitFor.split('; ') : [''];
  const marbleScoreListArray =
    marbleScore !== undefined ? marbleScore.split('; ') : [''];
  const arrayFitForAndMarbleScore = fitForListArray.map((item, index) => {
    return {
      fitFor: item,
      marbleScore:
        marbleScoreListArray[index] === undefined
          ? ''
          : marbleScoreListArray[index],
    };
  });

  return (
    <div className="aaco-product-kind relative">
      <div className="flex flex-col">
        {cloudinaryAssets.length > 0 && (
          <div className="product-kind-image mb-5">
            <DynamicAsset
              assets={cloudinaryAssets}
              entries={entries}
              field={cloudinaryAssets}
              container="container"
              style="aspect-[167/117] md:aspect-[10/7]"
            />
          </div>
        )}
        <div className="product-kind-header flex flex-row justify-between">
          <div className="product-kind-title flex flex-col">
            <Text tag="caption" style="text-black mb-2">
              {superTitle}
            </Text>
            <Text tag="h3" style="text-black">
              {title}
            </Text>
          </div>
          <div className="self-end">
            <div
              className={cn(
                'h-[61px] w-[61px] md:h-[87.26px] md:w-[87.26px] rounded-full',
                {
                  'bg-millet': title === 'Pure',
                  'bg-sorghum': title === 'Cross',
                  'bg-cooper-clover': title === 'Forage',
                }
              )}
            />
          </div>
        </div>

        <hr className="border-black my-8" />

        <div className="product-kind-content grid gap-y-4">
          {contentText &&
            contentText.content.length > 0 &&
            contentText.content.map(({ nodeType, content }, index) => (
              <RichText
                entries={entries}
                nodeType={nodeType}
                content={content}
                key={index}
                richTextStyle={{
                  paragraph: {
                    customFont: TEXT_BASE_CLASS['body'],
                  },
                }}
              />
            ))}
        </div>

        <hr className="border-black mt-8 mb-2" />

        <div className="product-kind-scores ">
          <table className="w-full">
            <thead className="leading-[5rem]">
              <tr className="text-left">
                <th className="w-[50%] pr-[18px]">
                  <Text tag="body" style="text-black">
                    Fit For
                  </Text>
                </th>
                <th className="w-[50%]">
                  <Text tag="body" style="text-black">
                    Marble Score
                  </Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {arrayFitForAndMarbleScore.map((item, index) => (
                <tr key={index} className="leading-[10px]">
                  <td
                    className={cn('pl-2 w-[50%] pr-[18px] ', {
                      'border-black border-l-1 ': item.fitFor !== '',
                    })}
                  >
                    <Text tag="caption" style="text-black">
                      {item.fitFor}
                    </Text>
                  </td>
                  <td className="w-[50%] border-l-1 pl-2 border-black">
                    <Text tag="caption" style="text-black">
                      {item.marbleScore}
                    </Text>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {callToAction && (
          <div className="product-kind-cta mt-5 md:mt-10">
            <CtfCta
              field={callToAction}
              entries={entries}
              onClick={(e, { localUrl, url, name }) =>
                analytics({
                  window,
                  document,
                  detail: getClickCtaDetail(e, { localUrl, url, name }),
                })
              }
              size="small"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductsKind;
